export default {
  isArray (ob) {
    return ob.constructor === Array
  },
  createOragnisationListModel (organisationResult, admins, accountManagers) {
    // console.log(JSON.stringify(organisationResult))
    let orgs = organisationResult.map(org => {
      return {
        id: org.id,
        name: org.name,
        state: org.state === undefined ? '' : org.state.toUpperCase(),
        inactive: org.inactive === undefined ? false : org.inactive,
        inactive_text: org.inactive === undefined ? 'active' : org.inactive === true ? 'inactive' : 'active',
        admin: admins.find(function (item) { return item.admin_id === org.admin_id }) || { admin_id: '', full_name: '' },
        account_manager: accountManagers.find(function (item) { return item.account_manager_id === org.account_manager_id }) || { account_manager_id: '', full_name: '' },
        admin_id: org.admin_id,
        account_manager_id: org.account_manager_id,
      }
    })
    return orgs
  },
  dayOfWeek (dayNumber) {
    var days = [
      'Sun',
      'Mon',
      'Tue',
      'Wed',
      'Thu',
      'Fri',
      'Sat',
    ]
    return days[dayNumber]
  },
  pad (n) {
    return n < 10 ? '0' + n : n
  },
  getLocalDateSimple (recordDate) {
    var date = new Date(recordDate)
    var outputDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0)
    return this.pad(outputDate.getDate()) + '/' + this.pad(outputDate.getMonth() + 1) + '/' + this.pad(outputDate.getFullYear())
  },
  getLocalDate (recordDate) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    var date = new Date(recordDate)
    var outputDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0)
    return this.dayOfWeek(outputDate.getDay()) + ', ' + this.pad(outputDate.getDate()) + ' ' + monthNames[outputDate.getMonth()] + ' ' + this.pad(outputDate.getFullYear())
  },
  getFormattedDate (createdDate) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    var date = new Date(createdDate)
    return this.pad(date.getDate()) + ' ' + monthNames[date.getMonth()] + ', ' + this.pad(date.getHours()) + ':' + this.pad(date.getMinutes())
  },
  createTimesheetModel (t) {
    // console.log(JSON.stringify(t))
    let timesheetModel = {
      id: t.id,
      records: t.records.map(r => {
        return {
          days: r.days,
          day: this.dayOfWeek(r.weekday),
          record_date: r.record_date,
          date: this.getLocalDate(r.record_date),
          sequence: r.sequence,
          locked: r.locked,
          weekday: r.weekday,
          holiday: r.holiday,
        }
      }),
      status: t.status,
      days: t.days != null ? t.days : 0,
      employee_id: t.employee_id,
      employee_name: t.employee_name,
      manager_id: t.manager_id,
      manager_name: t.manager_name,
      contract_id: t.contract_id,
      organisation_id: t.organisation_id,
      organisation_name: t.organisation_name,
      active: t.active,
      notes: t.notes != null ? t.notes.map(n => {
        return {
          note: n.note,
          created_at: n.created_at,
        }
      }) : [],
      events: t.events != null ? t.events.map(e => {
        return {
          event: e.event,
          created_at: e.created_at,
        }
      }) : [],
      comments: t.comments != null ? t.comments.map(c => {
        return {
          detail: c.detail,
          created_at: c.created_at,
          formatted_date: this.getFormattedDate(c.created_at),
          by: c.by,
        }
      }) : [],
      locked: t.locked === undefined ? false : t.locked,
    }
    // timesheetModel.hours = timesheetModel.records.reduce((a, b) => a.hours + b.hours, 0)
    // console.log(JSON.stringify(timesheetModel))
    return timesheetModel
  },
  createTimesheetListModel (timesheetResult) {
    let timesheets = timesheetResult.map(t => {
      return {
        id: t.id,
        status: t.status,
        days: t.days,
        start: t.start,
        end: t.end,
        period: this.formatPeriod(t.start, t.end),
        employee_name: t.employee_name,
        manager_name: t.manager_name,
        organisation_name: t.organisation_name,
      }
    })
    return timesheets
  },
  createContractListModel (contractResult, managers, employees, states) {
    let contracts = contractResult.map(contract => {
      return {
        id: contract.id,
        finished: contract.finished === undefined ? false : contract.finished,
        finish_date: this.getLocalDateSimple(contract.finish_date),
        start_date: this.getLocalDateSimple(contract.start_date),
        description: contract.description,
        employee_id: contract.employee_id,
        state: contract.state,
        selectedState: states.find(function (item) { return item.id === contract.state }) || { id: '', name: '' },
        employee: employees.find(function (item) { return item.employee_id === contract.employee_id }) || { employee_id: '', full_name: '' },
        employee_name: employees.find(function (item) { return item.employee_id === contract.employee_id }).full_name || '',
        manager_id: contract.manager_id,
        manager: managers.find(function (item) { return item.manager_id === contract.manager_id }) || { manager_id: '', full_name: '' },
        manager_name: managers.find(function (item) { return item.manager_id === contract.manager_id }).full_name || '',
        last_date: contract.last_date,
      }
    })
    // console.log(JSON.stringify(contracts))
    return contracts
  },
  createAdminListModel (adminResult) {
    let admins = adminResult.map(admin => {
      return {
        id: admin.user.id,
        name: admin.user.name,
        family: admin.user.family,
        full_name: admin.user.name + ' ' + admin.user.family,
        email_address: admin.user.email_address,
        invitation_sent: admin.user.invitation_sent === undefined ? false : admin.user.invitation_sent,
        external_id: admin.user.external_id,
        inactive: admin.user.inactive === undefined ? false : admin.user.inactive,
        email_verified: admin.user.email_verified === undefined ? false : admin.user.email_verified,
        role: {
          admin: admin.user.role.admin === undefined ? false : admin.user.role.admin,
          super_admin: admin.user.role.super_admin === undefined ? false : admin.user.role.super_admin,
          manager: admin.user.role.manager === undefined ? false : admin.user.role.manager,
          employee: admin.user.role.employee === undefined ? false : admin.user.role.employee,
        },
      }
    })
    return admins
  },
  createManagerListModel (managerResult, organisations) {
    let managers = managerResult.map(manager => {
      return {
        id: manager.user.id,
        name: manager.user.name,
        family: manager.user.family,
        full_name: manager.user.name + ' ' + manager.user.family,
        email_address: manager.user.email_address,
        invitation_sent: manager.user.invitation_sent === undefined ? false : manager.user.invitation_sent,
        external_id: manager.user.external_id,
        inactive: manager.user.inactive === undefined ? false : manager.user.inactive,
        email_verified: manager.user.email_verified === undefined ? false : manager.user.email_verified,
        role: {
          admin: manager.user.role.admin === undefined ? false : manager.user.role.admin,
          super_admin: manager.user.role.super_admin === undefined ? false : manager.user.role.super_admin,
          manager: manager.user.role.manager === undefined ? false : manager.user.role.manager,
          employee: manager.user.role.employee === undefined ? false : manager.user.role.employee,
        },
        organisation_id: manager.organisation_id,
        organisation: organisations.find(function (item) { return item.organisation_id === manager.organisation_id }) || { organisation_id: '', name: '' },
      }
    })
    // console.log(JSON.stringify(managers))
    return managers
  },
  formatPeriod (startString, endString) {
    var monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    var start = new Date(startString)
    var end = new Date(endString)
    var startDate = new Date(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate(), 0, 0, 0, 0)
    var endDate = new Date(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate(), 0, 0, 0, 0)
    return this.pad(startDate.getDate()) + ' ' + monthNames[startDate.getMonth()] + ' - ' + this.pad(endDate.getDate()) + ' ' + monthNames[endDate.getMonth()] + ', ' + this.pad(startDate.getFullYear())
  },
  createEmployeeListModel (employeeResult) {
    // console.log(JSON.stringify(employeeResult))
    let employees = employeeResult.map(employee => {
      return {
        id: employee.user.id,
        name: employee.user.name,
        family: employee.user.family,
        full_name: employee.user.name + ' ' + employee.user.family,
        email_address: employee.user.email_address,
        invitation_sent: employee.user.invitation_sent === undefined ? false : employee.user.invitation_sent,
        inactive: employee.user.inactive === undefined ? false : employee.user.inactive,
        external_id: employee.user.external_id,
        email_verified: employee.user.email_verified === undefined ? false : employee.user.email_verified,
        role: {
          admin: employee.user.role.admin === undefined ? false : employee.user.role.admin,
          super_admin: employee.user.role.super_admin === undefined ? false : employee.user.role.super_admin,
          manager: employee.user.role.manager === undefined ? false : employee.user.role.manager,
          employee: employee.user.role.employee === undefined ? false : employee.user.role.employee,
        },
      }
    })
    // console.log(JSON.stringify(employees))
    return employees
  },
  createManagerViewListModel (managerResult) {
    let managersView = managerResult.map(manager => {
      return {
        manager_id: manager.user.id,
        full_name: manager.user.name + ' ' + manager.user.family,
        first_name: manager.user.name,
        inactive: manager.user.inactive,
      }
    })
    var records = managersView.sort((a, b) => {
      return a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
    })
    console.log(JSON.stringify(records))
    return records
  },
  createEmployeeViewListModel (employeeResult) {
    let employeeView = employeeResult.map(employee => {
      return {
        employee_id: employee.user.id,
        full_name: employee.user.name + ' ' + employee.user.family,
        first_name: employee.user.name,
        inactive: employee.user.inactive,
      }
    })
    var records = employeeView.sort((a, b) => {
      return a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
    })
    console.log(JSON.stringify(records))
    return records
  },
  createOragnisationViewListModel (organisationResult) {
    let orgs = organisationResult.map(org => {
      return {
        organisation_id: org.id,
        name: org.name,
      }
    })
    var records = orgs.sort((a, b) => {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })
    console.log(JSON.stringify(records))
    return records
  },
  createAdminViewListModel (adminResult) {
    let adminViews = adminResult.map(admin => {
      return {
        admin_id: admin.user.id,
        full_name: admin.user.name + ' ' + admin.user.family,
        first_name: admin.user.name,
      }
    })
    var records = adminViews.sort((a, b) => {
      return a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
    })
    console.log(JSON.stringify(records))
    return records
  },
  createAccountManagerViewListModel (adminResult) {
    let accountManagerViews = adminResult.map(admin => {
      return {
        account_manager_id: admin.user.id,
        full_name: admin.user.name + ' ' + admin.user.family,
        first_name: admin.user.name,
      }
    })
    var records = accountManagerViews.sort((a, b) => {
      return a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
    })
    console.log(JSON.stringify(records))
    return records
  },
}
